import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./selectOption.css";

const SelectItem = ({
  values,
  handleSelectData,
  selectNum,
  label,
  defaultValue,
  selectPlaceholder,
  handleBlur,
  style,
}) => {
  return (
    <div className="selectData">
      <select
        value={defaultValue}
        onChange={handleSelectData}
        style={style}
        onBlur={handleBlur}
      >
        <option value="">{selectPlaceholder}</option>
        {values.map((item, index) => (
          <option key={index} value={item[selectNum]}>
            {item[label]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectItem;
